import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { CountryGuideService } from 'src/app/shared/services/countryGuide.service';
import { DownloadService } from 'src/app/shared/services/download.service';
import { QuotesService } from 'src/app/shared/services/quotes.service';
import { UserService } from 'src/app/shared/services/user.service';
import { UtilsService } from 'src/app/shared/services/utils.service';
import {Subject} from 'rxjs';

@Component({
  selector: 'app-transfer-quotes-dialog',
  templateUrl: './transfer-quotes-dialog.component.html',
  styleUrls: ['./transfer-quotes-dialog.component.scss']
})
export class TransferQuotesDialogComponent implements OnInit {
    resetFormSubject: Subject<any> = new Subject<any>();

  @ViewChild('quoteStep1') quoteStep1: NgForm;
  @ViewChild('quoteStep2') quoteStep2: NgForm;
  @ViewChild('quoteStep3') quoteStep3: NgForm;
  @ViewChild('quoteStep4') quoteStep4: NgForm;

  index = 0;
  isLoading = false;
  maxSteps = 5;
  selectedStepIndex = 0;

  allowEndClients = false;
  allowTeams = false;
  showRegions = true;
  TransferEORAssingmnetId = null;
  isFileUploadInProgress = false;

  countryGuide: any;
  existingQuoteId: any;
  updatedQuote: any;

  existingAssignment: any;
  existingEvaluationId: any;
  existingServiceId: number;

  Hposition: MatSnackBarHorizontalPosition = 'right';
  VPosition: MatSnackBarVerticalPosition = 'top';
  quoteMapCode:any;
  step1 = {
    selectedState: null,
    selectedCountry: null,
    service_type_id: null,
    selectedEndClient: null,
    title: null,
    city: null,
    selectedTeam: null,
    selectedServiceName: null,
    include_AOR: null,
    include_EOR: null,
    include_Compliance: null
  };

  step2 = {
    is_entity_in_country: null,
    number_of_workers: null,
    is_expat: null,
    is_expat_visa_required: null,
    is_worker_in_country: null,
    expat_nationality: null,

  };

  step3 = {
    job_description: null,
    job_description_file: null,
    is_travel_required: null,
    job_title: null,
    job_description_file_id: null,

  };

  step4 = {
    project_length_months: null,
    project_length_weeks: null,
    project_length_years: null,
    is_project_length_indefinite: null,
    start_date: null,
    weekly_hours: null,
    pay_rate: null,
    selectedCurrency: null,
    selectedPayRateType: null,
    is_commission_authorized: null,
    is_bonus_authorized: null,
    other_compensation: null,
    client_notes: null,

  };

  constructor(private userService: UserService,
              private router: Router,
              private downloadService: DownloadService,
              private dialogRef: MatDialogRef<TransferQuotesDialogComponent>,
              private toast: MatSnackBar,
              public countryGuideService: CountryGuideService,
              private utils: UtilsService,
              private quotesService: QuotesService,
              @Inject(MAT_DIALOG_DATA) private data: {
      existingAssignment: any,
      existingEvaluationId: any,
      existingServiceId: number
    }
    ) {
    this.existingAssignment = data.existingAssignment;
    }

  ngOnInit(): void {

    this.allowEndClients = this.userService.getAllowEndClients();
    this.allowTeams = this.userService.getAllowTeams();
    this.step1.include_EOR= !this.userService.getEORDisabled();
    this.step1.include_Compliance= !this.userService.getComplianceDisabled();
    this.step1.include_AOR= !this.userService.getAORDisabled();
    this.getCountryRegionCode(this.step1.selectedCountry, this.step1.selectedState)
    this.populateForm(this.existingAssignment);   
  }

  nextStep = () => {
    let canProceed = false;
    const stepIndex = this.selectedStepIndex + 1;

    switch (stepIndex) {
        case 1:
            canProceed = this.quoteStep1.valid;

            if (this.step1.selectedState == null && this.step1.selectedCountry.HasRegions === true
                && this.showRegions === true) {
                alert('Please select a state or region');
                canProceed = false;
            }

            // set the region to null if the country has no regions
            if (this.step1.selectedCountry.HasRegions === false) {
                this.step1.selectedState = null;
            }

            if (canProceed) {
                this.loadCountryGuide();
            }
            break;
        case 2:
            canProceed = this.quoteStep2.valid;
            break;
        case 3:
            canProceed = this.quoteStep3.valid;
            if
                (
                this.step1.service_type_id === 1 && // only for EOR
                (this.step3.job_description_file === '' || this.step3.job_description_file === null) &&
                (this.step3.job_description === '' || this.step3.job_description == null)
            ) {
                alert('Please enter the job description or upload a file');
                canProceed = false;
            }
            break;
        case 4:
            canProceed = this.quoteStep4.valid;
            if (this.step4.is_project_length_indefinite === false && (
                (this.step4.project_length_months === '' || this.step4.project_length_months === '0' ||
                    this.step4.project_length_months === 0) &&
                (this.step4.project_length_weeks === '' || this.step4.project_length_weeks === '0' ||
                    this.step4.project_length_weeks === 0) &&
                (this.step4.project_length_years === '' || this.step4.project_length_years === '0' ||
                    this.step4.project_length_years === 0)
            )) {
                canProceed = false;
                alert('Please Ensure the Length of Project is Valid');
            }
            break;
    }

    if (canProceed) {
        this.index = (this.selectedStepIndex === this.maxSteps) ? 0 : this.selectedStepIndex + 1;

        // for Compliance, skip to the end review after the first step
        if (this.step1.service_type_id === 3 || this.step1.service_type_id === 2) {
            this.index = 4;
        }

        this.saveDraft().then(() => {
            this.selectedStepIndex = this.index;
        });
    } else {
        // TODO: Focus on invalid element
    }
    this.resetFileErrorMessages();
  }

  canProceed = () => {
    const step = this.selectedStepIndex + 1;
    let valid = false;
    if (this['quoteStep' + step]) {
        valid = this['quoteStep' + step].$valid;

        // require a region to be selected for countries that support regions.
        if (step === 1) {
            if (this.step1.selectedCountry != null) {
                if (this.step1.selectedState == null && this.step1.selectedCountry.HasRegions === true && this.showRegions === true) {
                    valid = false;
                }
            }
        }

        if (step === 2) {
            if (this.step2.is_expat === true && this.step2.expat_nationality == null && this.step1.service_type_id === 1) {
                valid = false;
            }
        }

        // Do not show the Save & Continue button if there's not one of a job description file or text.
        if (step === 3) {
            if
                (
                this.step1.service_type_id === 1 && // only for EOR
                (this.step3.job_description_file === '' || this.step3.job_description_file === null) &&
                (this.step3.job_description === '' || this.step3.job_description === null)
            ) {
                valid = false;
            }
        }
    }

    return valid;
  }

  prevStep = () => {
    this.resetFileErrorMessages();
    this.selectedStepIndex -= 1;

    if (this.step1.service_type_id === 3 || this.step1.service_type_id === 2) {
        this.selectedStepIndex = 0;
    }
  }

  cancel(){
    this.dialogRef.close();
  }

  resetFileErrorMessages(): void{

  }

  submit = () => {
    // Submitted status
    const statusId = 2;
    return this.save(statusId).then((response) => {
        if (response.apiCallStatus==1) {
            this.cancel();
            this.showConfirmationToast('Thank you! We will respond to your request within 1 business day.');
            this.router.navigate(['quotes'], {queryParams: {service: this.step1.service_type_id}});
            // $state.go('app.quotes', { service: this.step1.service_type_id });
        } else {
            this.showConfirmationToast('Error submitting form.');
        }
    });
  }

  saveAsDraft = () => {
    this.saveDraft().then((response) => {
        if (response.ErrorCode == 200) {
          //  this.cancel();
          this.dialogRef.close();
            this.showConfirmationToast('Draft has been saved.');
           // this.router.navigate(['quotes'], {queryParams: {service: 1}});
           this.router.navigate(["/quotes"], 
        {queryParams:{ service: 1 }});
        } else {
            this.showConfirmationToast('Error saving draft.');
            // console.error(error);
        }
    });
  }

  saveDraft() {
    // Draft status
    const statusId = 1;
    return this.save(statusId);
  }

  save(statusId) {
    this.isLoading = true;

    const props = {
        new_status_id: statusId
    };

    if (this.quoteStep1.valid) {
      Object.assign(props, {
            service_type_id: this.step1.service_type_id,
            title: this.step1.title,
            city: this.step1.city,
            end_client_id: (this.step1.selectedEndClient != null) ? this.step1.selectedEndClient.ID : 0,
            country_id: this.step1.selectedCountry.ID,
            start_date: this.step4.start_date,
            team_id: (this.step1.selectedTeam != null) ? this.step1.selectedTeam.ID : 0,
            transfer_eor_assignment_id : this.TransferEORAssingmnetId
        });

      this.step1.selectedServiceName = this.utils.getServiceName(this.step1.service_type_id);

      if (this.step1.selectedState) {
          Object.assign(props, {
                state_id: this.step1.selectedState.ID,
            });
        }
    }

    if (this.quoteStep2.valid) {
      Object.assign(props, {
            is_entity_in_country: this.step2.is_entity_in_country,
            number_of_workers: this.step2.number_of_workers,
            is_expat: this.step2.is_expat,
            is_expat_visa_required: this.step2.is_expat_visa_required,
            is_worker_in_country: this.step2.is_worker_in_country,
            expat_nationality_id: (this.step2.expat_nationality != null) ? this.step2.expat_nationality.ID : null,
        });
    }


    if (this.quoteStep3.valid) {

        // reload the file name and id
        this.repopulateFileUploads();

        Object.assign(props, {
            is_travel_required: this.step3.is_travel_required,
            job_title: this.step3.job_title,
            job_description: this.step3.job_description,
            job_description_file: this.step3.job_description_file,
            job_description_file_id: this.step3.job_description_file_id,
            /*type_of_work: this.step3.type_of_work,*/
        });

    }
    if (this.quoteStep4.valid) {
      Object.assign(props, {
            weekly_hours: this.step4.weekly_hours,
            pay_rate: this.step4.pay_rate,
            project_length_years: this.step4.project_length_years,
            project_length_months: this.step4.project_length_months,
            project_length_weeks: this.step4.project_length_weeks,
            is_project_length_indefinite: this.step4.is_project_length_indefinite,
            start_date: this.step4.start_date,
            currency_id: this.step4.selectedCurrency.ID,
            pay_rate_type_id: this.step4.selectedPayRateType.ID,

            // Add commission handling to quote request
            is_commission_authorized: this.step4.is_commission_authorized,
            is_bonus_authorized: this.step4.is_bonus_authorized,
            other_compensation: this.step4.other_compensation,

            client_notes: this.step4.client_notes
            // payment_type_id: this.step4.selectedPayment.ID,
            // is_expat_visa_required: 'true'
        });
    }

    if (this.existingQuoteId) {
        return this.quotesService.update(this.existingQuoteId, props)
        .toPromise()
        .then(data => {this.onSaveSuccess(data); return data; })
        .catch(err => this.onSaveError(err));
    } else {
      return  this.quotesService.save(props)
      .toPromise()
      .then(data => {this.onSaveSuccess(data); return data; })
      .catch(err => this.onSaveError(err));
    }
  }

  onSaveSuccess(response) {
    this.isLoading = false;
    if (response.data.ErrorCode === 406) {
        this.index = 0;
        alert(response.data.ErrorMessage);
    } else {
        if (response.data.ErrorCode != 200) {           
        }
        this.existingQuoteId = response.data.Data.ID;
        // Let everyone know that there has been a change
        // Hided for redirect issue while creating an engagement in the Transfer to EOR quote..
        // $rootScope.$emit('iwg.quote.change');
    }
  }

  onSaveError(error) {
    this.isLoading = false;
    console.error(error);
  }

  repopulateFileUploads() {
    this.quotesService.getQuotesById(this.existingQuoteId)
    .subscribe(
      quote => {        
        this.isLoading = false;
        if (quote.apiCallStatus !== 1){
          return;
        }
        this.updatedQuote = quote.data.Data;      

        // if (updatedQuote.QuoteRequest.JobDescriptionFile) {
        if (this.updatedQuote.QuoteRequest_JobDescriptionFile_ID != null) {
            this.step3.job_description_file = this.updatedQuote.
                QuoteRequest_JobDescriptionFile_Name;      // updatedQuote.QuoteRequest.JobDescriptionFile.Name;
            this.step3.job_description_file_id = this.updatedQuote.
                QuoteRequest_JobDescriptionFile_ID;       // updatedQuote.QuoteRequest.JobDescriptionFile.ID           
        }
    });
  }

  loadCountryGuide() {
    if (this.step1.selectedCountry && this.step1.selectedState) {
      this.countryGuideService.getCountryGuidesDetail(this.step1.selectedCountry.ID, this.step1.selectedState.ID)
      .subscribe(response => {
        this.countryGuide = response.data.Data;
      });
    }
    else if (this.step1.selectedCountry) {
      this.countryGuideService.getCountryGuidesDetail(this.step1.selectedCountry.ID, 'null')
      .subscribe(response => {
        this.countryGuide = response.data.Data;
      });
    }
  }


  showConfirmationToast(text){
    this.toast.open(text, 'Got it', {
      duration: 2000, horizontalPosition: this.Hposition,
      verticalPosition: this.VPosition,
      panelClass: 'iwg-toast-text-white',
    });
  }

  downloadJobDescriptionFile = () => {
    this.downloadService.saveAs('/Api/File/' + this.step3.job_description_file_id).then(() => {       
    });
  }

  OnChangeServiceType() {
    this.SetServiceLabels();
  }

  SetServiceLabels() {
    if (this.step1.service_type_id === 3 || this.step1.service_type_id === 2) {
        this.maxSteps = 2;
        this.allowEndClients = false;
        this.showRegions = false;
    } else {
        this.maxSteps = 5;
    }
  }

  OnChangeDuration = (hint) => {
    if (hint === 'years' || hint === 'months' || hint === 'weeks') {
        this.step4.is_project_length_indefinite = false;
        if (this.step4.project_length_months == null || this.step4.project_length_months == '') {
            this.step4.project_length_months = 0;
        }
        if (this.step4.project_length_weeks == null || this.step4.project_length_weeks == '') {
            this.step4.project_length_weeks = 0;
        }
        if (this.step4.project_length_years == null || this.step4.project_length_years == '') {
            this.step4.project_length_years = 0;
        }
    }
    else if (hint === 'indefinite') {
        this.step4.project_length_years = '';
        this.step4.project_length_months = '';
        this.step4.project_length_weeks = '';
    }
  }
  populateForm(existingAssignment) {
    // eee: Enable services based on user access rights.

    Object.assign(this.step1, {
        include_EOR: !this.userService.getEORDisabled(),
        include_Compliance: !this.userService.getComplianceDisabled(),
        include_AOR: !this.userService.getAORDisabled()
    });
    if (existingAssignment) {

      Object.assign(this.step1, {
        service_type_id:   1,      // quoteRequest.Service.ServiceTypeEnumID,
        title: existingAssignment.Title,  //existingAssignment.Title,        
           // city: existingAssignment.City,      //quoteRequest.City,
            country_id: existingAssignment.Country.ID,   // quoteRequest.Country.ID,
            team_id: (existingAssignment.Team != null) ? existingAssignment.Team.ID : 0       // existingQuote.Team.ID,
        });

      this.TransferEORAssingmnetId = existingAssignment.DisplayID;    
    //  this.step1.selectedCountry = existingAssignment.Country;
    this.step1.selectedCountry = {
      ID: existingAssignment.Country.ID,
      Abbreviation: existingAssignment.Country.Abbreviation,
      HasRegions: existingAssignment.Country.HasRegions,
      Name: existingAssignment.Country.Name
  };
      this.step1.selectedTeam = existingAssignment.Team;
      this.step1.selectedTeam = {
        ID: existingAssignment.Team?.ID,
        Name: existingAssignment.Team?.Name
    };
    this.getCountryRegionCode(this.step1.selectedCountry?.Abbreviation, this.step1.selectedState)
      if (existingAssignment.Region != null) {
            this.step1.selectedState = existingAssignment.Region;
        }

      Object.assign(this.step4, {
          start_date: new Date(existingAssignment.StartDate),
        });
        this.step4.selectedCurrency = {
          ID: existingAssignment.QuoteRequest_PayCurrency_ID,
          Symbol: existingAssignment.QuoteRequest_PayCurrency_Symbol,
          Abbreviation: existingAssignment.QuoteRequest_PayCurrency_Abbreviation
      };

      //this.step4.selectedPayRateType = quoteRequest.PayPeriodicity;
      this.step4.selectedPayRateType = {
          ID: existingAssignment.QuoteRequest_PayPeriodicity_ID,
          Name: existingAssignment.QuoteRequest_PayPeriodicity_Name
      };
    }
  }
    getCountryRegionCode(countryCode, regionCode){       
        // this.step1.selectedCountry=countryCode;
        this.step1.selectedState = this.step1.selectedState === null ? regionCode : this.step1.selectedState;
        let code;

        if (regionCode && regionCode.Abbreviation.length > 2) {
            code = regionCode.Abbreviation;
        } else if (regionCode && regionCode.Abbreviation.length == 2) {
            code = countryCode + '-' + regionCode.Abbreviation;
        } else {
            code = countryCode;
        }
        this.quoteMapCode = code; 
        this.resetFormSubject.next(code);
    }
}
